/*
 * @Author: Yolo
 * @Date: 2024-07-19 09:11:46
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-19 09:24:51
 * @Desc 船舶事故
 */

import L from 'leaflet'
import {
  AreaViewBase,
  type AreaViewBaseOptions,
} from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import { result } from '@map-sdk/sdk/plugins/AreaView/layer/ShipAccidentData'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import 'leaflet.heat'

class ShipAccidentSymbol extends AreaViewBase {
  constructor(map: MyMap, options?: Partial<AreaViewBaseOptions>) {
    super(map, { ...(options || {}), minzoom: 3 })
    this._data = result
  }
  _show() {
    this._areaLayers.push(
      L.heatLayer(this._data, {
        minOpacity: 0.6,
        radius: 15,
      }).addTo(this._map)
    )
  }
}

const shipAccidentSymbol = (
  map: MyMap,
  options?: Partial<AreaViewBaseOptions>
): ShipAccidentSymbol => new ShipAccidentSymbol(map, options)

export { shipAccidentSymbol, ShipAccidentSymbol }
